import { render } from "./index.vue?vue&type=template&id=564e064e&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=564e064e&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564e064e"]])

export default __exports__